import React, { Component } from 'react';

import { toaster } from 'evergreen-ui';
import List from './List';

import { ClientList } from './style/ClientList';
import { ContentTitle } from '../../utilities/styledComponents/ContentTitle';

export default class Clients extends Component {
	componentDidMount() {
		const { location } = this.props;

		if (location.state && location.state.clientEdited) {
			toaster.success('Cliente atualizado com sucesso!');
		}
	}

	render() {
		return (
			<ClientList>
				<div className="page-container ">
					<article className="position-relative" id="home-page">
						<div className="content-welcome p-0">
							<ContentTitle>Listagem de clientes</ContentTitle>

							<List />
						</div>
					</article>
				</div>
			</ClientList>
		);
	}
}
